let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "149",
        trackFullPrice: '800',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Online stream access + Recordings',
        trackLink: 'https://geekle.us/ticket/1678202701282x255928117981085700',
        // earlyBird: true,
    },
    {
        trackTitle: "NO RECORDINGS access",
        trackSubtitle: "For Junior specialists",
        trackPrice: "89",
        trackNextPrice: "119",
        trackFullPrice: '500',
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1679301825603x722685180603269100',
        // earlyBird: true,
    },
    {
        trackTitle: "2 Software Development Event",
        event1: "AI in Software Development Conf'23",
        event2: "JavaScript Global Summit'23",
        event2Link: "https://events.geekle.us/js23/",
        trackPrice: "199",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: '2 Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1683019316094x494353598929698800',
    },
    {
        trackTitle: "Year of AI in Software Development Events",
        year: "Full Access to the live stream and recordings for 4 events in the AI in Software Development domain",
        trackPrice: "499",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Online stream access + Recordings',
        trackLink: 'https://geekle.us/ticket/1683108188912x698003381215559700',
    },
];

export default PackagesItem;
